export const environment = {
  production: false,
  apiUrl: 'https://apidev.ugchub.ru/v1',
  imgUrlStorage: 'https://apidev.ugchub.ru/storage/',
  webSocket: 'wss://wsdev.ugchub.ru'
};
